/**
 * Custom HTML element for displaying a Swiper carousel of related products.
 *
 * This class initializes a Swiper instance on a child element with the class
 * .swiper.related-products-swiper when the element is connected to the DOM.
 * It provides carousel functionality with navigation controls and cleans up
 * the Swiper instance when disconnected.
 *
 * @class RelatedProductsSwiper
 * @extends HTMLElement
 *
 * @example
 * <related-products-swiper>
 *   <div class="swiper">
 *     <!-- Swiper slides here -->
 *   </div>
 *   <div class="button-next"></div>
 *   <div class="button-prev"></div>
 * </related-products-swiper>
 */
class RelatedProductsSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cacheElements();
    this.initSwiper();
    this.showArrows();
    this.bindEvents();
  }

  cacheElements() {
    this.swiper = null;
    this.sectionId = this.dataset.sectionId;
    this.swiperElement = this.querySelector(".swiper");
    this.countItems =
      this.swiperElement.querySelectorAll(".swiper-slide").length;
    this.swiperButtonNext = this.querySelector(".swiper-button-next");
    this.swiperButtonPrev = this.querySelector(".swiper-button-prev");
    this.hasArrows = this.checkLiWidthVsUl();

    // console.log("Swiper element", this.swiperElement, this.checkLiWidthVsUl());
  }

  bindEvents() {
    this.swiperButtonNext.addEventListener("click", this.next.bind(this));
    this.swiperButtonPrev.addEventListener("click", this.prev.bind(this));
  }

  initSwiper() {
    if (this.swiperElement) {
      this.swiper = new Swiper(this.swiperElement, {
        slidesPerView: "auto",
        spaceBetween: 5,
        loop: true,
        breakpoints: {
          990: {
            spaceBetween: 5,
          },
        },
      });
    }
  }

  next() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }
  prev() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  checkLiWidthVsUl() {
    const ulElement = this.querySelector(".swiper-wrapper");

    if (!ulElement) {
      console.error("UL element not found");
      return false;
    }

    const liElements = ulElement.querySelectorAll("li");

    // Calculate total width of all li elements
    let totalLiWidth = 0;
    liElements.forEach((li) => {
      totalLiWidth += li.offsetWidth;
    });

    // Get ul width
    const ulWidth = ulElement.offsetWidth;

    // Return true if sum of li widths >= ul width
    // console.log({totalLiWidth, ulWidth})
    return totalLiWidth * 1.05 >= ulWidth;
  }

  showArrows() {
    setTimeout(() => {
      if (!this.hasArrows) {
        this.swiperButtonNext.style.display = "none";
        this.swiperButtonPrev.style.display = "none";
      }
    }, 200);
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  disconnectedCallback() {
    this.destroySwiper();
  }
}

if (!customElements.get("related-products-swiper")) {
  customElements.define("related-products-swiper", RelatedProductsSwiper);
}
